import type { TableColumn } from 'liyu-pc-base/typing';

export default () => {
  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      checked: true,
      width: 70,
      fixed: 'left',
    },
    {
      title: 'ID',
      width: 150,
      dataIndex: 'id',
      checked: false,
      ellipsis: true,
      resizable: true,
    },
    {
      title: '标题',
      width: 150,
      dataIndex: 'name',
      checked: true,
      ellipsis: true,
      resizable: true,
    },
    {
      filterMultiple: true,
      cellComponent: 'tag',
      contentMap: {
        simple: '简单匹配',
        regex: '正则匹配',
      },
      colorMap: {
        simple: 'green',
        regex: 'cyan',
      },
      filters: [
        {
          value: 'simple',
          text: '简单匹配',
        },
        {
          value: 'regex',
          text: '正则匹配',
        },
      ],
      title: '匹配类型',
      width: 150,
      dataIndex: 'match_type',
      checked: true,
      ellipsis: true,
      resizable: true,
      formatExcelValue: 'tag',
    },
    {
      title: '路径匹配',
      width: 150,
      dataIndex: 'content',
      checked: true,
      ellipsis: true,
      resizable: true,
    },
    {
      title: '文件',
      width: 150,
      dataIndex: 'files',
      checked: true,
      ellipsis: true,
      resizable: true,
      cellComponent: 'pdf',
      formatExcelValue: 'file',
    },
    {
      filterMultiple: false,
      cellComponent: 'tag',
      contentMap: {
        true: '可用',
        false: '禁用',
      },
      colorMap: {
        true: 'green',
        false: 'red',
      },
      filters: [
        {
          value: 'true',
          text: '可用',
        },
        {
          value: 'false',
          text: '禁用',
        },
      ],
      title: '是否可用',
      width: 150,
      dataIndex: 'is_active',
      checked: true,
      ellipsis: true,
      resizable: true,
      formatExcelValue: 'tag',
    },
    {
      contentFunc: '({text}) => getDateTime(text)',
      title: '创建时间',
      width: 150,
      dataIndex: 'create_time',
      checked: true,
      ellipsis: true,
      resizable: true,
    },
    {
      contentFunc: '({text}) => getDateTime(text)',
      title: '更新时间',
      width: 150,
      dataIndex: 'update_time',
      checked: true,
      ellipsis: true,
      resizable: true,
    },
  ];
  const formModalConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'vertical',
      col: [],
    },
    dynamicFieldList: [
      {
        children: [
          {
            type: 'input',
            name: 'name',
            label: '标题',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            maxlength: 100,
            defaultValue: '',
            placeholder: '请填写标题',
            span: 24,
            required_condition: null,
          },
          {
            type: 'radio',
            name: 'match_type',
            label: '匹配类型',
            disabled: false,
            allowClear: true,
            labelKey: 'name',
            valueKey: 'value',
            defaultValue: '',
            placeholder: '请选择匹配类型',
            span: 24,
            required_condition: null,
            queryType: 'advanced',
          },
          {
            type: 'remotecomplete',
            label: '路径匹配',
            disabled: false,
            allowClear: true,
            valueKey: 'menu_path',
            labelKeyType: 1,
            labelKey: 'name',
            labelKeyList: [],
            labelSpace: '-',
            mode: 'default',
            placeholder: '请输入内容',
            show_search: true,
            datasourceType: 'remote',
            queryType: 'advanced',
            searchConditions: [
              [
                {
                  searchType: 3,
                  field_name: 'is_active',
                  operator: 'eq',
                  value: [true],
                  format: 'choices',
                  class_name: 'bool',
                },
              ],
            ],
            simpleSearchConditions: [
              {
                searchType: 3,
                field_name: 'is_active',
                value: true,
              },
            ],
            postUrl: '/permission/query_menu_list',
            name: 'content',
            span: 24,
            pull: 0,
            push: 0,
            offset: 0,
          },
          {
            type: 'upload',
            label: '文件',
            disabled: false,
            access_type: 'public',
            maxCount: 1,
            listType: 'picture',
            group: 'sys',
            span: 24,
            acceptList: ['.pdf'],
            name: 'files',
            placeholder: '请输入文件',
            pull: 0,
            push: 0,
            offset: 0,
            queryType: 'advanced',
          },
        ],
      },
    ],
    model: {
      update_field_list: ['name', 'match_type', 'content', 'files'],
      name: null,
      match_type: 'simple',
      files: [],
    },
    rules: {
      name: [
        {
          required: true,
          message: '请填输入标题',
        },
      ],
    },
    options: {
      match_type: [
        {
          name: '简单匹配',
          value: 'simple',
          valueType: 'str',
        },
        {
          name: '正则匹配',
          value: 'regex',
          valueType: 'str',
        },
      ],
    },
  };
  const updateFormModalConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'vertical',
      col: [],
    },
    dynamicFieldList: [
      {
        children: [
          {
            type: 'input',
            name: 'name',
            label: '标题',
            disabled: false,
            allowClear: true,
            inputType: 'text',
            maxlength: 100,
            defaultValue: '',
            placeholder: '请填写标题',
            span: 24,
            required_condition: null,
          },
          {
            type: 'radio',
            name: 'match_type',
            label: '匹配类型',
            disabled: false,
            allowClear: true,
            labelKey: 'name',
            valueKey: 'value',
            defaultValue: '',
            placeholder: '请选择匹配类型',
            span: 24,
            required_condition: null,
          },
          {
            type: 'remotecomplete',
            label: '路径匹配',
            disabled: false,
            allowClear: true,
            valueKey: 'menu_path',
            labelKeyType: 1,
            labelKey: 'name',
            labelKeyList: [],
            labelSpace: '-',
            mode: 'default',
            placeholder: '请输入路径匹配',
            show_search: true,
            datasourceType: 'remote',
            queryType: 'advanced',
            searchConditions: [
              [
                {
                  searchType: 3,
                  field_name: 'is_active',
                  operator: 'eq',
                  value: [true],
                  format: 'choices',
                  class_name: 'bool',
                },
              ],
            ],
            simpleSearchConditions: [
              {
                searchType: 3,
                field_name: 'is_active',
                value: true,
              },
            ],
            postUrl: '/permission/query_menu_list',
            name: 'content',
            span: 24,
            pull: 0,
            push: 0,
            offset: 0,
          },
          {
            type: 'upload',
            label: '文件上传',
            disabled: false,
            access_type: 'public',
            maxCount: 1,
            listType: 'picture',
            group: 'sys',
            span: 24,
            acceptList: ['.pdf'],
            name: 'files',
            placeholder: '请选择文件上传',
            pull: 0,
            push: 0,
            offset: 0,
            queryType: 'advanced',
          },
        ],
      },
    ],
    model: {
      update_field_list: ['name', 'match_type', 'content', 'files'],
      name: null,
      match_type: 'simple',
      files: [],
    },
    rules: {
      name: [
        {
          required: true,
          message: '请填输入标题',
        },
      ],
    },
    options: {
      match_type: [
        {
          name: '简单匹配',
          value: 'simple',
          valueType: 'str',
        },
        {
          name: '正则匹配',
          value: 'regex',
          valueType: 'str',
        },
      ],
    },
  };

  return {
    baseColumns,
    formModalConfig,
    updateFormModalConfig,
  };
};
